import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { TableHead } from './table';

export type SortDirection = 'asc' | 'desc';

export function SortableTableHead({
	children,
	className,
	sortKey,
	activeKey,
	direction,
	onSort,
	...props
}: React.ComponentProps<'th'> & {
	sortKey: string;
	activeKey: string;
	direction: SortDirection;
	onSort: (key: string) => void;
}) {
	const isActive = sortKey === activeKey;

	return (
		<TableHead className={cn('cursor-pointer select-none', className)} {...props}>
			<button
				onClick={() => onSort(sortKey)}
				className="inline-flex items-center gap-1 bg-transparent text-[inherit] font-[inherit] uppercase tracking-[inherit]"
			>
				{children}
				{isActive ? (
					direction === 'asc' ? (
						<ArrowUp size={11} className="text-text-2" />
					) : (
						<ArrowDown size={11} className="text-text-2" />
					)
				) : (
					<ArrowUpDown size={11} className="text-text-4/50" />
				)}
			</button>
		</TableHead>
	);
}
